module.exports = __webpack_public_path__ + "img/logo-pci-compliance.e4e3cca.png";